const BASE_URL = "https://script.google.com/macros/s/";
const {REACT_APP_LIMIT  } = process.env;
export const MemberShipAPI = process.env.REACT_APP_MemberShipAPI
export const MemberShipAPIKEY = process.env.REACT_APP_API_KEY_Service



// export const MachineListEndPoint =BASE_URL + "AKfycbwHtgATJ5NiE9WRUm5C3vkvQL5NqzrggHW148daoExmoC4FQtidVaX-jWfXTKktIf-x/exec";
export const MachineListEndPoint =process.env.REACT_APP_MachineListEndPoint;
  
export const ConfigurationEndPoint = process.env.REACT_APP_ConfigurationEndPoint;
  

// https://script.google.com/macros/s/AKfycbwHtgATJ5NiE9WRUm5C3vkvQL5NqzrggHW148daoExmoC4FQtidVaX-jWfXTKktIf-x/exec




export const CurrentUser = function CurrentUser() {
  var users = localStorage.getItem("_ms-mem");
  return JSON.parse(users);
};
export const FullDataWithPlan = function FullDataWithPlan() {
  var users = localStorage.getItem("user");
  
  return JSON.parse(users);
};

export const getLocalEligibalSub = function getLocalEligibalSub() {
  var eligibleSubscribers = localStorage.getItem("eligibalsub");
  return JSON.parse(eligibleSubscribers);
};
export const getRegMachineLimit = function getRegMachineLimit() {
  var config = localStorage.getItem("configuraions");
  var configuraions = JSON.parse(config?config:"" );
  return configuraions.RegMachineLimit;
};

export const getDisclaimerDocLink = function getDisclaimerDocLink() {
  var config = localStorage.getItem("configuraions");
  if(config!==undefined && config!=="" && config!==null)
  {
  var configuraions = JSON.parse(config?config:{} );
  return configuraions.DisclaimerDocLink;
  }

};
